/** The six site languages a feature copy table carries for every key. */
const COPY_TABLE_LANGUAGES = ["en", "nl", "de", "fr", "es", "it"] as const;

type CopyTableLanguage = (typeof COPY_TABLE_LANGUAGES)[number];

export type CopyTableEntry = { key: string } & Record<
  CopyTableLanguage,
  string
>;

const isCopyTableLanguage = (value: string): value is CopyTableLanguage =>
  (COPY_TABLE_LANGUAGES as readonly string[]).includes(value);

/**
 * The in-code text of a copy table entry in the page's language, English only
 * when the language is unknown. Used as `t()`'s `defaultValue`, so a key that
 * is missing from Lokalise or from a half-loaded namespace still reads in the
 * page's own language instead of English (WHO-6641).
 */
export const copyTableFallback = (
  entry: CopyTableEntry,
  language: string | undefined
) => (language && isCopyTableLanguage(language) ? entry[language] : entry.en);
